import { useEffect, useRef, useState } from 'react';

/**
 * Compares `value` against the snapshot taken the first time `ready` is true
 * (e.g. once initial data has loaded), reporting whether it has since changed.
 */
export function useIsDirty<T>(value: T, ready: boolean): boolean {
    const initialSnapshot = useRef<string | null>(null);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        if (!ready) return;
        const serialized = JSON.stringify(value);
        if (initialSnapshot.current === null) {
            initialSnapshot.current = serialized;
            setIsDirty(false);
            return;
        }
        setIsDirty(serialized !== initialSnapshot.current);
    }, [value, ready]);

    return isDirty;
}